import { render, staticRenderFns } from "./quoted-assessed.vue?vue&type=template&id=d9966b24&"
import script from "./quoted-assessed.vue?vue&type=script&lang=js&"
export * from "./quoted-assessed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports